<template>
  <div>
    <v-dialog v-model="isOpenDialog" width="620px" class="color">
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title>CHI TIẾT HÓA ĐƠN</v-toolbar-title>
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-card-text id="element-to-convert">
          <InfoStudentBill />
          <DetailBillByStudent />
          <InfoBankAccountTeacher />

          <div class="summary_wrap" v-if="detailPeriod.status !== 'created'">
            <div class="summary_final">
              <p>Tổng kết cuối:</p>
              <span>{{ detailPeriod.updatedAt | ddmmyyyyhhmm }}</span>
            </div>
            <div class="summary_people">
              <p>Người tổng kết:</p>
              <span>{{ detailPeriod.generatedBy ? detailPeriod.generatedBy.name : '' }}</span>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-btn depressed color="primary" class="px-6 ml-2 mt-n4 mb-2 white--text" @click="summarizing()"
            >TỔNG KẾT LẠI</v-btn
          >
          <v-spacer />
          <v-btn depressed color="primary" class="px-6 mr-2 mt-n4 mb-2 white--text d-none" @click="exportToPDF()"
            >XUẤT FILE PDF</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import html2pdf from 'html2pdf.js'
import DetailBillByStudent from './DetailBillByStudent.vue'
import InfoBankAccountTeacher from './InfoBankAccountTeacher.vue'
import InfoStudentBill from './InfoStudentBill.vue'
export default {
  components: {
    InfoStudentBill,
    DetailBillByStudent,
    InfoBankAccountTeacher,
  },
  data() {
    return {
      isOpenDialog: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      report: 'tuitionFeeReport/report',
    }),
  },
  methods: {
    ...mapActions('tuitionFeeReport', ['summarizingEachStudent', 'fetchOne']),
    async openDialog() {
      this.$loading.active = true
      await this.fetchOne(this.report.id)
      this.$loading.active = false
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
    },
    exportToPDF() {
      let convertFullDate = this.$options.filters.convertFullDate(this.detailPeriod.title)
      html2pdf(document.getElementById('element-to-convert'), {
        filename: `${this.report.student.name}_${this.report.student.code.substr(0, 5)}_${convertFullDate}.pdf`,
      })
    },
    summarizing() {
      this.$dialog.confirm({
        title: 'Xác nhận tổng kết lại?',
        text: 'Các thông tin cũ trong hóa đơn có thể bị thay đổi và<br/>không thể hoàn tác. Bạn có chắc chắn muốn tổng kết lại hóa đơn cho Học viên này',
        cancelText: 'Hủy',
        okText: 'Xác nhận',
        done: async () => {
          try {
            this.$loading.active = true
            await this.summarizingEachStudent({ studentId: this.report.student.id, periodId: this.detailPeriod.id })
            this.$loading.active = false
            this.$alert.success('Đã tổng kết lại thành công!')
          } catch (e) {
            this.$loading.active = false
            let msg = {
              title: 'Lỗi thao tác',
              description: 'Hệ thống đang thực hiện tổng kết. Vui lòng chờ.',
            }
            if (e === 'Connection fail') {
              msg = {
                title: 'Lỗi kết nối',
                description: 'Không thể thực hiện tổng kết. Vui lòng thử lại.',
              }
            }
            this.$alert.error({ title: msg.title, description: msg.description })
          }
        },
      })
    },
  },
}
</script>
<style lang="scss">
#element-to-convert {
  font-family: 'Roboto';
}

.margin {
  margin: 10px 0;
}

.summary_wrap > .summary_final,
.summary_people {
  display: flex;
  margin: 12px 12px 12px 20px;
}

.summary_wrap > .summary_final p,
.summary_people p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 8px 0 0;
}

.total_money {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.total_money h3,
.total_money span {
  color: #fd6b6b;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
</style>
